import { z } from 'zod';
export const VoiceAgentBindingKeySchema = z
    .object({
    contentKey: z.string().min(1).max(200),
    moderatorId: z.string().max(100),
    provider: z.enum(['elevenlabs', 'vapi']),
})
    .strict();
export const VoiceAgentBindingClaimSchema = z
    .object({
    agentId: z.string().nullable(),
    leaseToken: z.string().uuid().nullable(),
})
    .strict();
export const CompleteVoiceAgentBindingSchema = VoiceAgentBindingKeySchema.extend({
    leaseToken: z.string().uuid(),
    agentId: z.string().min(1).optional(),
}).strict();
//# sourceMappingURL=VoiceAgentBinding.js.map